// ============================================================
//  Iconic Moments — shared slot config + normaliser
//  Single source of truth for the Home "Iconic Moments" mosaic
//  and the Admin manager. Stored in site settings under the key
//  `homeIconicMoments` (a JSON array). No SQL/table changes:
//  the existing settings store already holds arbitrary JSON.
// ============================================================

// Fixed editorial slot blueprint (shape + intended orientation).
// `span` / `aspect` drive the premium mosaic rhythm on desktop.
export const ICONIC_SLOTS = [
  { slot: 1, role: "Tall Portrait",    aspect: "3/4",    colSpan: 1, rowSpan: 2 },
  { slot: 2, role: "Landscape",        aspect: "3/2",    colSpan: 2, rowSpan: 1 },
  { slot: 3, role: "Square / Medium",  aspect: "1/1",    colSpan: 1, rowSpan: 1 },
  { slot: 4, role: "Portrait",         aspect: "4/5",    colSpan: 1, rowSpan: 1 },
  { slot: 5, role: "Portrait",         aspect: "3/4",    colSpan: 1, rowSpan: 1 },
  { slot: 6, role: "Landscape",        aspect: "3/2",    colSpan: 2, rowSpan: 1 },
  { slot: 7, role: "Detail / Small",   aspect: "1/1",    colSpan: 1, rowSpan: 1 },
  { slot: 8, role: "Landscape",        aspect: "3/2",    colSpan: 2, rowSpan: 1 },
  { slot: 9, role: "Optional",         aspect: "4/5",    colSpan: 1, rowSpan: 1 },
];

// One blank, disabled slot record.
export function emptySlot(slot) {
  return {
    slot,
    imageUrl: "",
    alt: "",
    caption: "",
    position: "center", // top | center | bottom
    fit: "cover",       // cover | contain
    enabled: false,
  };
}

// Always return exactly ICONIC_SLOTS.length records, in slot order,
// merging whatever the admin has saved. Safe against null / object /
// partial / out-of-order data.
export function normaliseIconicMoments(raw) {
  let arr = raw;
  if (typeof arr === "string") {
    try { arr = JSON.parse(arr); } catch { arr = []; }
  }
  if (arr && !Array.isArray(arr) && typeof arr === "object") {
    arr = Object.values(arr);
  }
  if (!Array.isArray(arr)) arr = [];

  const bySlot = new Map();
  arr.forEach((item, i) => {
    if (!item || typeof item !== "object") return;
    const n = Number(item.slot) || i + 1;
    bySlot.set(n, item);
  });

  return ICONIC_SLOTS.map(({ slot }) => {
    const saved = bySlot.get(slot) || {};
    return {
      ...emptySlot(slot),
      ...saved,
      slot,
      position: ["top", "center", "bottom"].includes(saved.position) ? saved.position : "center",
      fit: saved.fit === "contain" ? "contain" : "cover",
      enabled: Boolean(saved.enabled && (saved.imageUrl || "").trim()),
    };
  });
}

// Slots actually shown on the public Home page: enabled + has an image,
// preserved in slot order (never reordered, never auto-filled).
export function publicIconicMoments(raw) {
  return normaliseIconicMoments(raw).filter(s => s.enabled && (s.imageUrl || "").trim());
}

// map position -> object-position value
export function positionToObjectPosition(position) {
  if (position === "top") return "center 18%";
  if (position === "bottom") return "center 82%";
  return "center 38%"; // face-safe centre (slightly high)
}
